import AddFeedbackNamIT from "./AddFeedbackNAMIT";

const EditInvFeedbackNAMIT = () => {
  return <AddFeedbackNamIT isEdit={true} />;
};

export default EditInvFeedbackNAMIT;
